<aside class="side-menu__container" [ngClass]="{'side-menu__container-active': showMenu}" (click)="toggleMenu()">
  <nav class="slide-menu" [ngClass]="{'slide-menu-active': showMenu}" (click)="$event.stopImmediatePropagation();">
    <section class="menu-header">

    </section>
    <section class="menu-body"></section>
    <section class="menu-footer"></section>
  </nav>
</aside>

<router-outlet></router-outlet>

<div class="root__container">
  <main class="main__container" style="height: 100vh;">
    <div class="main-container__bg" [ngClass]="{'main-container__bg-dark': darkModeActive}">

    </div>
    <ul>
      <li *ngFor="let value of apiValues">{{value}}</li>
    </ul>
    <router-outlet></router-outlet>
  </main>
</div>
